import { useMemo } from 'react';

const useOptions = (messages) => {

  const entities = useMemo(() => [
    { id: "Landmark", label: messages['alertsNewAlert_Landmark_name'] || "Landmark" },
    { id: "All", label: messages['alertsNewAlert_Landmark_all'] || "All" },
  ], [messages]);

  const parameterOrder = useMemo(() => [
    { id: "landmark.landmarkName_asc", name: messages['dashboardPanel_landmark_name_asc'] },
    { id: "landmark.landmarkName_desc", name: messages['dashboardPanel_landmark_name_desc'] },
    { id: "visits_asc", name: messages['dashboardPanel_number_vehicle_asc'] },
    { id: "visits_desc", name: messages['dashboardPanel_number_vehicle_desc'] }
  ], [messages]);

  return { entities, parameterOrder };
};

export default useOptions;
